import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './fixed-hint.module.css'

const propTypes = {
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    iconComponent: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string,
    titleClassName: PropTypes.string
}

/**
 * The fixed hint component as specified by UX (see molecules section). Basically it is a box with dynamic height
 * containing a vertically centered, left aligned icon and text floating to the right of the icon. All styles like
 * the icon dimension, padding, margin, colors, ... are defined through the theme.
 *
 * @param {ReactElement}  props.iconComponent  - object of type SvgIcon, the icon to be rendered on the left side
 * @param {string}        props.text           - the text floating to the right of the icon
 * @param {string}        props.className      - className to style whole element
 * @param {string}        props.iconClassName  - className to style icon
 * @param {string}        props.titleClassName - className to style title
 * @param {string}        props.title		   - the text to show as headline
 * @param {ReactElement}  props.children       - children to get rendered within component
 * @return {ReactElement}
 */
export function FixedHint({ children, className, iconClassName, iconComponent, text, title, titleClassName }) {
    const Icon = iconComponent
    const headline = title ? <span className={cx(styles['fixed-hint-title'], titleClassName)}>{title}</span> : null
    return (
        <div className={cx('t3sel-fixed-hint', styles['fixed-hint-box'], className)}>
            <div className={cx(styles['fixed-hint-icon'], iconClassName)}>
                <Icon fillParent />
            </div>
            <div className={styles['fixed-hint-text-container']}>
                {headline}
                {text}
                {children}
            </div>
        </div>
    )
}

FixedHint.propTypes = propTypes
